import { AppShell, Card } from '~/ui/primitives';

export function NotSupported() {
  return (
    <AppShell maxWidth={520}>
      <Card>
        <h1
          style={{ margin: '0 0 var(--space-3)', font: '600 24px/1.25 var(--font-display)', letterSpacing: '-0.01em' }}
        >
          Browser not supported
        </h1>
        <p style={{ margin: '0 0 var(--space-4)', color: 'var(--text-secondary)' }}>
          SCP Wallet uses WebAuthn passkeys with the PRF extension. This browser doesn't support WebAuthn, or reported
          that it can't provide a PRF-capable passkey. You don't need Touch ID or Windows Hello — a phone passkey or a
          security key works too.
        </p>
        <p style={{ margin: '0 0 var(--space-2)', font: '500 14px/1.4 var(--font-sans)' }}>
          Open this page in a recent version of:
        </p>
        <ul
          style={{
            margin: 0,
            paddingLeft: '1.1rem',
            color: 'var(--text-secondary)',
            font: '400 14px/1.7 var(--font-sans)',
          }}
        >
          <li>Chrome 116+ or Edge 116+ (desktop or Android)</li>
          <li>Safari 18+ (macOS 15 / iOS 18)</li>
          <li>…or scan the sign-in QR with a phone whose passkeys support PRF</li>
        </ul>
      </Card>
    </AppShell>
  );
}
